import axios from 'axios';
import toastr from '../../general/js/toastr';

let instance = axios.create({
    timeout: 30000,
    withCredentials: true,
});

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

instance.interceptors.request.use((config) => {
    config.headers['X-Ensure-Content'] = getPageId();
    return config;
});

instance.interceptors.response.use((response) => {
    return response;
}, (error) => {

    if (!axios.isCancel(error)) {
        if(error && error.response){
            console.error(error.response);
            if (!isValidationError(error)) {
                showErrorNotification(error);
            }
        }
    }

    return Promise.reject(error);
});

export function isValidationError({response: {status, data}}) {
        return (status === 400) && (typeof data === 'object') && ('errors' in data);
}

export function getValidationErrors({response: {data}}) {
    return data.errors;
}

function showErrorNotification({response: {status}}) {
    let message;
    switch (status) {
        case  404:
            message = 'Not found';
            break;
        default:
            message = 'Sorry for inconvenience. Please try again later';
    }

    toastr.error(message, 'Request failed');
}

let pageId = null;

function getPageId() {
    if (pageId === null) {
        pageId = document.body.getAttribute('data-page-id');
    }

    return pageId;
}

export default instance;




// WEBPACK FOOTER //
// ./app/general/js/api.js